import { Box } from '@bechtel/gds';
import { Skeleton } from '../skeleton';

export const RightPanelSkeleton = () => {
  return (
    <Box flexGrow={{ sm: 1 }} style={{ gap: '2%' }} flexDirection={{ sm: 'column' }} p={{ sm: '450' }}>
      <Skeleton width="100%" height="20%" borderRadius="200" />
      {Array.from({ length: 3 }).map((item, index) => {
        return <Skeleton key={index} width="100%" height="5%" borderRadius="200" />;
      })}
      <Skeleton width="100%" height="20%" borderRadius="200" />
    </Box>
  );
};
